var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8038 12.8417L13.8263 11.8642C13.3379 11.3758 12.5463 11.3758 12.0588 11.8642L11.2904 12.6325C11.1188 12.8042 10.8588 12.8617 10.6371 12.7642C9.52378 12.2767 8.42378 11.5375 7.44295 10.5567C6.46628 9.57999 5.72961 8.48499 5.24128 7.37583C5.13961 7.14666 5.19878 6.87749 5.37628 6.69999L6.06461 6.01166C6.62378 5.45249 6.62378 4.66166 6.13545 4.17333L5.15795 3.19583C4.50711 2.54499 3.45211 2.54499 2.80128 3.19583L2.25795 3.73833C1.64045 4.35583 1.38295 5.24666 1.54961 6.12999C1.96128 8.30749 3.22628 10.6917 5.26711 12.7325C7.30795 14.7733 9.69211 16.0383 11.8696 16.45C12.7529 16.6167 13.6438 16.3592 14.2613 15.7417L14.8038 15.1992C15.4546 14.5483 15.4546 13.4933 14.8038 12.8417V12.8417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 4.82584C10.6922 4.81417 11.5555 5.13251 12.2113 5.78834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.568 3.43167C13.2605 2.12417 11.5463 1.47 9.83301 1.47",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1734 8.16666C13.1851 7.3075 12.8668 6.44416 12.2109 5.78833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5684 3.43167C15.8759 4.73917 16.53 6.45334 16.53 8.16667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.cd0db797195880c2c1cb22a6f8356207.svg";
export { ForwardRef as ReactComponent };